<template>
    <div>
        <div class="is-clearfix has-background-white columns plisttable" style="border-radius: 10px 10px 0 0;">
            <template v-if="loading">
                <div class="column"></div>
                <p class="content has-text-centered is-size-6" style="padding-top:120px;">
                    正在加载...
                </p>
                <div class="column"></div>
            </template>
            <template v-if="!loading">
                <p class="content  " style="padding-top:10px;" v-html="note"></p>
            </template>
        </div>
        <div class="is-clearfix has-text-centered has-background-white columns" style="padding: 30px;border-radius: 0 0 10px 10px;">
            <div class="column"></div>
            <router-link :to="{ name: 'RecPostReg', query: { id: postid, pid: planid } }">
                <button class="button is-danger" type="button">我已阅读并完全理解，现在去报名</button>
            </router-link>
            <div class="column"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecPlanNote',
    data() {
        return {
            loading: true,
            note: '',
            planid: '',
            postid: ''
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.planid = this.$route.query.pid
            this.postid = this.$route.query.id
            this.doLoad()
        },
        doLoad() {
            this.loading = true
            this.$http
                .get('/comm/data/plan/note', {
                    params: {
                        _: new Date().getTime() / 1000 / 60,
                        id: this.$route.query.pid
                    }
                })
                .then(result => {
                    this.note = result.data.note || '暂无公告'
                    this.loading = false
                })
        }
    }
}
</script>
